import { __assign, __rest } from "tslib";
import React from 'react';
import { useForkRef, useLongPress, useThemeProps, } from '../../../foundation';
import { useRcDialerContext } from '../utils';
var holdTime = 1000;
var RcDialDelete = function (inProps) {
    var props = useThemeProps({ props: inProps, name: 'RcDialDelete' });
    var onDelete = props.onDelete, onClear = props.onClear, children = props.children;
    var _a = useRcDialerContext(), onClearRef = _a.onClearRef, onDeleteRef = _a.onDeleteRef;
    var handleClear = function (e, reason) {
        var _a;
        onClear === null || onClear === void 0 ? void 0 : onClear(e, reason);
        (_a = onClearRef === null || onClearRef === void 0 ? void 0 : onClearRef.current) === null || _a === void 0 ? void 0 : _a.call(onClearRef, e, reason);
    };
    var handleDelete = function (e, reason) {
        var _a;
        onDelete === null || onDelete === void 0 ? void 0 : onDelete(e, reason);
        (_a = onDeleteRef === null || onDeleteRef === void 0 ? void 0 : onDeleteRef.current) === null || _a === void 0 ? void 0 : _a.call(onDeleteRef, e, reason);
    };
    var _b = useLongPress({ onTap: handleDelete, onPress: handleClear }, children.props, { delay: holdTime, externalWindow: props.externalWindow }), ref = _b.ref, events = __rest(_b, ["ref"]);
    var forkEleRef = useForkRef(children.props.ref, ref);
    return React.cloneElement(children, __assign({ ref: forkEleRef }, events));
};
export { RcDialDelete };
